(function ($, Drupal, drupalSettings, once) {
  Drupal.behaviors.alert = {
    attach: function (context, settings) {
      once("alert", ".alert", context).forEach(function (element) {
        $(element).on("click", ".close", function () {
          $(this).closest(".alert").slideUp(200);
        });
      });
    },
  };
})(jQuery, Drupal, drupalSettings, once);
